exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__button___2fb3X{padding:.4em .9em;border-radius:5px;font-weight:500;text-transform:uppercase;font-size:18px;letter-spacing:1px;color:#fff}", ""]);

// exports
exports.locals = {
	"button": "index-module__button___2fb3X"
};